export default __webpack_public_path__ + "static/media/chart2.187fc5ea.png";